import React from "react";
import apiUrl from "../shared/config";
import {FiveIcon, FourIcon, OneIcon, SixIcon, ThreeIcon, TwoIcon, ZeroIcon} from "../components/Icons/Icons";
export function removeAllEndParentheses(string) {
    return removeChar(string, ')')
}

export function removeChar(string, char) {
    const str = String(string)
    return str.split(char).join('');
}

export const formatParagraphs = (text, paddingBottom = 8, tabSize = '2ch') => {
    const str = String(text)
    return str.split('\n').map((paragraph, index) => (
        <p key={index} style={{
            paddingBottom: paddingBottom,
            marginBottom: 0,
            tabSize: tabSize,
        }}>{paragraph}</p>
    ));
};

export function haveSameFields(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if both objects have the same number of keys
    if (keys1.length !== keys2.length) {
        return false;
    }

    // Check if all keys in obj1 exist in obj2
    return keys1.every(key => keys2.includes(key));
}

/**
 * Checks that a string is not null, undefined, and has text that is not exclusively spaces.
 * @param text the value of a text field
 * @returns {boolean}
 */
export function validStringField(text) {
    if (text) {
        const str = String(text);
        return !!str.trim();
    } else {
        return false
    }
}

export function devLog(args) {
    if (apiUrl === "http://localhost/PatternLibrary/") {
        console.log(...args)
    }
}

export function number_to_icon (order_id) {
    switch (order_id) {
        case "1":
            return <OneIcon/>
        case "2":
            return <TwoIcon/>
        case "3":
            return <ThreeIcon/>
        case "4":
            return <FourIcon/>
        case "5":
            return <FiveIcon/>
        case "6":
            return <SixIcon/>
        default:
            return <ZeroIcon/>
    }
}

/**
 * Return the name that should be displayed for a user. If there is no username it should display 'firstname lastname'
 * if available, if not it should display firstname if available, then lastname, then 'Unknown User'.
 * @param displayName {string | null | undefined} the users display name
 * @param firstname {string | null | undefined} the users first name
 * @param lastname {string | null | undefined} the user's last name
 * @returns {string}
 *
 * @link See tests at: https://replit.com/@tbelk/JestTest
 */
export function getDisplayName(displayName, firstname, lastname) {
    // Check if displayName is a non-empty string
    if (displayName?.trim()) {
        return displayName.trim();
    }

    // If displayName is empty, return firstname + lastname if available
    const first = firstname?.trim();
    const last = lastname?.trim();

    if (first || last) {
        return `${first || ''} ${last || ''}`.trim();
    }

    // Return 'Unknown User' if no valid name is found
    return 'Unknown User';
}